module.exports = __webpack_public_path__ + "img/ECS (3D) v2 Gold (250x250).015056ff.png";